import { AnyAction, CombinedState, applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
import createSagaMiddleware from 'redux-saga';
import thunk from 'redux-thunk';
import { AppState } from 'types';
import reducers from './reducers';
import { watchAuth, watchFav, watchGroups, watchHelp, watchLogs, watchPost, watchRecent, watchUser } from './sagas';

const sagaMiddleware = createSagaMiddleware();

export const appReducer = combineReducers(reducers);

export const rootReducer = (state: CombinedState<AppState> | undefined, action: AnyAction): CombinedState<AppState> => {
  if (action.type === 'AUTH_LOGOUT') {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export const composeEnhancers = process.env.NODE_ENV === 'development' ? composeWithDevTools({}) : compose;

export const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk, sagaMiddleware)));

sagaMiddleware.run(watchAuth);
sagaMiddleware.run(watchUser);
sagaMiddleware.run(watchLogs);
sagaMiddleware.run(watchPost);
sagaMiddleware.run(watchGroups);
sagaMiddleware.run(watchFav);
sagaMiddleware.run(watchRecent);
sagaMiddleware.run(watchHelp);

export default {};
